import React from 'react';
import PropTypes from 'prop-types';
import MorePropTypes from 'airbnb-prop-types';
import { withStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { DialogActions } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Close from '@material-ui/icons/Close';
import Fab from '@material-ui/core/Fab';

const propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({}).isRequired,
  open: PropTypes.bool.isRequired,
  anchorEl: MorePropTypes.or([PropTypes.shape({}), PropTypes.func]).isRequired,
  handleClick: PropTypes.func.isRequired,
  handleClickAway: PropTypes.func.isRequired,
  placement: PropTypes.string.isRequired,
  popperId: MorePropTypes.or([MorePropTypes.explicitNull, PropTypes.string.isRequired]),
  closeButton: PropTypes.bool,
};

const defaultProps = {
  popperId: null,
  closeButton: true,
};

export function UnstyledPopoutItem({
  children,
  classes,
  anchorEl,
  open,
  handleClick,
  handleClickAway,
  placement,
  popperId,
  closeButton,
}) {
  return (
    <Popper
      id={popperId}
      open={open}
      anchorEl={anchorEl}
      className={classes.root}
      placement={placement}
      modifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'window',
        },
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <ClickAwayListener onClickAway={handleClickAway} disableReactTree>
        <Paper>
          {children}
          {closeButton && (
            <DialogActions classes={{ root: classes.dialog }}>
              <Fab size="small" classes={{ root: classes.cancelButton }} onClick={handleClick}>
                <Close fontSize="large" />
              </Fab>
            </DialogActions>
          )}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}

UnstyledPopoutItem.propTypes = propTypes;
UnstyledPopoutItem.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    zIndex: '1300',
    maxWidth: '100%',
    display: 'flex',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  dialog: {
    flex: '1 1 100%',
    justifyContent: 'space-between',
    margin: 0,
    padding: 0,
  },
  cancelButton: {
    position: 'absolute',
    marginLeft: theme.spacing(1),
    left: theme.spacing(1),
    bottom: theme.spacing(2),
    color: theme.customColors.white,
    backgroundColor: theme.customColors.teal,
    '&:hover': {
      background: theme.customColors.teal,
    },
  },
});

export default withStyles(styles)(UnstyledPopoutItem);
